import type { PostKidsRequest, PostKidsResponse } from '~/api/aspida/@types';
import { sendRequest } from '~/api/sendRequest';

export const postKids = sendRequest<PostKidsRequest, PostKidsResponse>({
  url: '/kids',
  method: 'post',
});
